export enum DataGridErrorType {
    Error = 'error',
    RequiredError = 'requiredError',
    Warning = 'warning',
}
